// extracted by mini-css-extract-plugin
export default {"wrapper":"prolile-orders_wrapper__l7jrr","container":"prolile-orders_container__IvOl6","scrollbar":"prolile-orders_scrollbar__foHEb","srollbar":"prolile-orders_srollbar__MXjAe"};